import React, {useState} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {getDeliveryOrderBatches,} from "../../deliveryOrderBatches/deliveryOrderBatchesActions";
import ITEM_TEMPERATURE from "../../components/constants/itemTemperature";

const AdminDeliveryDayViewOrderBatchPackingMode = ({orderBatch, closeModal, setModalOrder}) => {
  const [packedOrderIds, setPackedOrderIds] = useState([]);

  return (
    <div className="m-b-6">
      <h2 className="m-b-6"><FormattedMessage id={`order.batch.packing.mode.header`}
                                              values={{id: orderBatch.user.id, name: orderBatch.user.screenName}}/></h2>

      <div className="m-b-6">
        {orderBatch.orders.map((order, index) => {
          const tempEnums = Object.keys(ITEM_TEMPERATURE).map((key) => ITEM_TEMPERATURE[key]);

          const packedIndex = packedOrderIds.indexOf(order.id);

          const onCheck = () => {
            const newPackedIds = packedOrderIds.slice();

            if (packedIndex !== -1) {
              newPackedIds.splice(packedIndex, 1)
            } else {
              newPackedIds.push(order.id);
            }

            setPackedOrderIds(newPackedIds);
          };

          return (
            <div key={index} className="m-b-6">
              <h4 className={packedIndex !== -1? 'text-muted': ''}>
                <span className="m-r-2">
                  <input
                    name="packed"
                    type="checkbox"
                    checked={packedIndex !== -1}
                    onChange={onCheck} />

                </span>
                <span onClick={onCheck}>
                    {order.marketplaceName}
                  </span> - <small className=" link"
                                                onClick={() => setModalOrder(order)}><FormattedMessage
                id={'delivery.day.view.order.refund'}/></small>
              </h4>

              <ul>
                {order.items.map((orderItem, index) => {
                  const temperature = orderItem.item.temperature?
                    tempEnums.find(value => value.name === orderItem.item.temperature): null;
                  return (
                    <li className={`text-large ${packedIndex !== -1? 'text-muted': ''}`} key={index}>
                      {orderItem.quantity > 1 ? (<strong
                        className="text-primary">{orderItem.quantity} x </strong>) : ''} {orderItem.itemName} {temperature? temperature.icon: ''}
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>

      <div className="m-b-2 m-t-6">
        <button className="btn btn-primary" onClick={() => closeModal()}>
          <FormattedMessage id={`order.batch.packing.mode.done`}/>
        </button>
      </div>
      <div>
        <button className="btn btn-default" onClick={() => closeModal()}>
          <FormattedMessage id={`order.batch.packing.mode.close`}/>
        </button>
      </div>
    </div>
  );
}

AdminDeliveryDayViewOrderBatchPackingMode.propTypes = {
  orderBatch: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  setModalOrder: PropTypes.func.isRequired,
};

AdminDeliveryDayViewOrderBatchPackingMode.defaultProps = {};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

const mapDispatchToProps = {
  getDeliveryOrderBatches,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(AdminDeliveryDayViewOrderBatchPackingMode));